<template>
    <button class="gz-button" @click.stop="$emit('click')" :title="title">
        <span v-show="icon && !loading" :class="icon" :style="value ? 'margin-right: 5px' : ''"></span>
        <span v-show="value && !loading" v-html="value"></span>
        <span v-show="loading" class="gz-loader gz-loader_sm spin-cw"></span>
    </button>
</template>

<script>
export default {
    name: 'BaseButton',

    props: {
        value: {
            type: String
        },
        title: {
            type: String
        },
        icon: {
            type: String
        },
        loading: {
            type: Boolean,
            default: false
        }
    }
}
</script>